import {FieldErrors} from 'react-hook-form';
import {ErrorMessage} from '@hookform/error-message';
import {cn} from '@/lib/utils';

type Props = {
  errors: FieldErrors;
  name: string;
  className?: string;
};

export default function InputSpecificError({errors, name, className}: Props) {
  return (
    <ErrorMessage
      errors={errors}
      name={name}
      render={({message}) => (
        <i
          className={cn(
            'text-error-primary font-thin text-xs mt-2',
            className,
          )}>
          {message}
        </i>
      )}
    />
  );
}
